import { Component, EventEmitter,OnInit, Input,Output,Inject, inject, DestroyRef } from '@angular/core';
import { Sandbox } from 'src/app/models/sandbox';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { TrialStatusService } from 'src/app/services/util/trial-status.service';
import { translate } from '@jsverse/transloco';
import {SolutionsService} from 'src/app/services/api/solutions.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {BlueprintsService} from '../../../services/api/blueprints.service';
import {InstancesService} from '../../../services/api/instances.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';

@Component({
    selector: 'app-sandbox-card',
    templateUrl: './sandbox-card.component.html',
    styleUrls: ['./sandbox-card.component.scss'],
    standalone: false
})
export class SandboxCardComponent implements OnInit {

  @Input() sandbox: Sandbox;
  @Input() sandboxCardInfo: any;
  @Input() loader: boolean;
  private destroyRef = inject(DestroyRef);

  readonly statusInfo: { [key: string]: any } = {
    //TODO - Add other statuses or change them whenever the designs will be defined for them
    [DeployStatus.DEPLOYED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.DEPLOYING]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [DeployStatus.FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'},
    [DeployStatus.TERMINATING]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [DeployStatus.TERMINATION_FAILED]: {icon: 'error_outline', colorClass: 'warn-solid-bg'},
    [DeployStatus.NOT_DEPLOYED]: {icon: 'close', colorClass: 'neutral-blue-6-bg'},
    [DeployStatus.UPDATED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.UPDATE_FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'}
  };

  trialStatus: string;
  version: string;
  capabilitiesCount: number;
  DeployStatus = DeployStatus;
  extendSandboxMessage: boolean;
  releaseVersion: any;
  isAMR: boolean;
  isSandbox: boolean;

  constructor(private blueprintsService: BlueprintsService,private solutionsService: SolutionsService,
    private authService: AuthService, private router: Router, private trialStatusService: TrialStatusService,
    private instanceService: InstancesService, private solutionVersionsService: SolutionVersionsService) {
  }

  ngOnInit(): void {
    if(!this.loader){
      this.loadData();
      this.trialStatus = this.trialStatusService.TrailStatusUTCFormat(this.sandbox?.instance);
      this.loadInstances();
    }
  }

  loadData(): void {
    const serviceId = this.sandbox?.instance?.solutionId;
    this.solutionsService.getSolutionVersions(serviceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.version = result[0].version;
        this.releaseVersion = result[0]?.releaseVersion;
        if(this.releaseVersion && this.solutionVersionsService.releaseVersion(this.releaseVersion)) {
          this.isAMR = true;
        }
      });


  }


  /**
   * After clicking a sandbox card, the endpoints page will be opened next
   */
  goToEndpoints(): void {
    if(this.sandbox?.instance?.status && (this.sandbox?.instance?.status === DeployStatus.DEPLOYED || DeployStatus.UPDATED)){
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.sandbox.service.id,
        RouterSegments.BLUEPRINTS, this.sandbox.instance.blueprintId]);
    }
  }

  private loadInstances(): void {
    this.instanceService.getInstancesForSolution(this.sandbox?.instance?.solutionId)
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
    (instances: any) => {
      instances.filter((x) => {
        if (x.name === translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX') && x.blueprintId === this.sandbox?.instance?.blueprintId) {
          if (x.dateCreated !== x.dateUpdated) {
            this.extendSandboxMessage = true;

          }
        }
      });
    });
  }

}
